@use 'themes/westfield' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;

.contentWrapper {
  flex: 1;
  padding: units(1) units(1.25) units(3.5);
  background-color: color('backgroundPrimary');

  @include fromBreakpoint(tablet) {
    padding: units(1.5) units(3) units(4);
  }

  form {
    button {
      font-weight: 500;
    }

    button[type='submit'] {
      background: #1c1f24;

      &:hover {
        background: #686870;
      }

      &:disabled {
        background: #f5f6f7;
      }

      &:disabled path {
        fill: #d9dadd;
      }
    }

    label {
      @include font-size(1);
      font-weight: 500;
    }

    :not(button) > span {
      @include font-size(0);
    }

    input[type='text'],
    input[type='email'],
    input[type='password'] {
      @include font-size(1);
      background: color('surfaceTertiary');
    }

    > * + * {
      margin-top: units(1.5);
    }
  }
}

.notifications {
  max-width: columns(6);
  margin: 0 auto units(2);

  @include fromBreakpoint(tablet) {
    max-width: columns(7);
  }
}

.notification {
  margin-bottom: units(1);

  &:last-child {
    margin-bottom: 0;
  }
}
